import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';

const DAYS_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const RestaurantTimingHeader = ({ vendorTimings }) => {
    const theme = useTheme();

    if (!vendorTimings || vendorTimings.length === 0) return null;

    const todayIndex = dayjs().day();
    const todayTiming = vendorTimings.find(t => t.day_of_week === todayIndex);

    if (!todayTiming) return null;

    const formatTime = (timeStr) => dayjs(`2000-01-01 ${timeStr}`).format('hh:mm A');

    const timingText = todayTiming.is_open
        ? todayTiming.slots.map(s => `${formatTime(s.open_time)} - ${formatTime(s.close_time)}`).join(', ')
        : "Closed";

    return (
        <Box sx={{
            mb: 1,
            p: 1,
            backgroundColor: '#f8f9fa',
            borderRadius: '10px',
            border: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1
        }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#555' }}>
                Today's Timing ({DAYS_FULL[todayIndex]}):
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: todayTiming.is_open ? theme.palette.primary.main : '#ff4d4f' }}>
                {timingText}
            </Typography>
        </Box>
    );
};

export default RestaurantTimingHeader;
